import { Input as FInput } from '@folksam/ui-next/components';
import React from 'react';
import { useField } from 'react-final-form';
import { useTranslation } from 'react-i18next';
import { combineValidators, required, validOrgnr } from '../../../services/validators.service';
import FormField from '../../FormField';

// ^(([12356789]{1}[0-9]{5})[0-9|-]{4,5})$
function OrganizationNumber({ label, ...props }) {
    const { t } = useTranslation();

    // Define validators to match old angular validators, with matching error text from commondata translations
    const validators = combineValidators([
        required(t('empty_mandatory_error')),
        validOrgnr(t('error_companyssn_format'))
    ]);

    const { input, meta } = useField(props.name, { validate: validators });

    return (
        <FormField
            label={label}
            meta={meta}
            id={props.fieldId}
            component={FInput}
            inputProps={{
                maxlength: '13',
                className: `sessioncamexclude`,
                ...props,
                id: props.fieldId,
                ...input,
                postfix: props.infoButton
            }}
        />
    );
}
export default OrganizationNumber;
